<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 md4>
        <v-card
          color="primary"
          dark
          :v-if="(user && user.is_instructor) || $hasRole('organisation-admin')"
          @click="viewCourse(upcomingCourse.id)"
          class="widget-course"
        >
          <div v-if="_.has(upcomingCourse, 'id')">
            <v-card-text class="pb-5">
              <v-card-title class="headline pl-0 pt-0" style="background: transparent !important">{{ upcomingCourse.name }}</v-card-title>
              <v-card-subtitle>
                {{ $t("dashboard.duration") }}:
                {{
                  moment.utc(upcomingCourse.start_date).format(DATE_FORMAT) +
                  " " +
                  moment.utc(upcomingCourse.start_time, TIME_FORMAT).format(TIME_FORMAT)
                }}
                -
                {{
                  moment.utc(upcomingCourse.end_date).format(DATE_FORMAT) +
                  " " +
                  moment.utc(upcomingCourse.end_time, TIME_FORMAT).format(TIME_FORMAT)
                }}
                <br />
                {{ $t("dashboard.enrolled") }}: {{ upcomingCourse.num_enrolled_enrolment }} <br />
                {{ $t("dashboard.students") }}: {{ upcomingCourse.num_enrolled_attendees }}
              </v-card-subtitle>
            </v-card-text>
            <v-card-actions>
              <span class="pl-2 course-status font-weight-black">{{ $dd_course_status(upcomingCourse.status) }}</span>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                class="darken-2"
                @click.stop="checkIn(upcomingCourse.id)"
                v-if="moment(upcomingCourse.start_date).format(DATE_FORMAT) == moment().format(DATE_FORMAT)"
                >{{ $t("checkin.check_in_btn") }}</v-btn
              >
              <v-btn
                color="success"
                class="darken-2"
                @click.stop="attendance(upcomingCourse.id)"
                v-if="moment(upcomingCourse.start_date).format(DATE_FORMAT) != moment().format(DATE_FORMAT)"
                >{{ $t("checkin.attendance_btn") }}</v-btn
              >
            </v-card-actions>
          </div>

          <div v-if="!_.has(upcomingCourse, 'id')">
            <v-card-text>
              <v-card-title class="headline pl-0 pt-0">{{ $t("dashboard.no_upcoming_course") }}</v-card-title>
            </v-card-text>
          </div>
        </v-card>
      </v-flex>
      <v-flex xs12 md8>
        <v-card :v-if="(user && user.is_instructor) || $hasRole('organisation-admin')">
          <v-card-text class="py-1">
            <v-data-table
              class="upcoming-courses"
              :hide-default-footer="true"
              :headers="computedHeaders"
              :items="courses"
              :items-per-page="courses.length"
              :options.sync="pagination"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                'items-per-page-all-text': $t('global.items_per_page_all_text'),
                'items-per-page-text': $t('global.items_per_page_text'),
                'page-text': $t('global.page_text')
              }"
              :server-items-length="total"
              :loading="show_loading"
              :loading-text="$t('global.loading_text')"
              :no-data-text="$t('global.no_data_text')"
              :no-results-text="$t('global.no_results_text')"
              :must-sort="true"
            >
              <template v-slot:item.category="{ item }">
                {{ item.coursetype.category }}
              </template>

              <template v-slot:item.instructor="{ item }">
                {{ item.instructor.fullname }}
              </template>

              <template v-slot:item.start_datetime="{ item }">
                {{
                  item.start_date
                    ? moment.utc(item.start_date).format(DATE_FORMAT) + " " + moment.utc(item.start_time, TIME_FORMAT).format(TIME_FORMAT)
                    : null
                }}
                -
                {{
                  item.end_date
                    ? moment.utc(item.end_date).format(DATE_FORMAT) + " " + moment.utc(item.end_time, TIME_FORMAT).format(TIME_FORMAT)
                    : null
                }}
              </template>

              <template v-slot:item.status="{ item }">
                {{ $dd_course_status(item.status) }}
              </template>

              <template v-slot:item.actions="{ item }">
                <router-link :to="{ path: BACKEND_URL + '/courses/edit/' + item.id, props: { id: item.id } }" v-if="$can('course-edit')">
                  <action-button type="edit" small :icon_only="true" />
                </router-link>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <!--<v-flex xs12 md4>
                <v-btn @click="paymentStart">Klarna Payment</v-btn>
                <v-btn @click="checkOutStart">Klarna Checkout</v-btn>
            </v-flex>-->
    </v-layout>

    <!--<klarna-payment 
            :show="klarna_show" 
            :type="klarna_type"
            :order_data="klarna_order_data"
            @klarna_success="klarnaSuccess"
            @klarna_failed="klarnaFailed"
            @klarna_cancel="klarnaClear" />-->
  </v-container>
</template>

<script>
export default {
  name: "dashboard",

  components: {
    "report-course-overview": () => import("../../reports/components/charts/ReportCourseOverview")
    //"klarna-payment": () => import("@/mixins/components/klarnaPayment"),
  },

  data() {
    return {
      upcomingCourse: {},
      courses: [],

      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: 5,
        sortBy: ["start_datetime"],
        descending: "desc"
      },
      search_params: {
        not_in_ids: "",
        statuses: "1,5", // Upcoming and Ongoing
        start_date: "gt-now",
        instructor_id: null
      }

      /*klarna_show: false,
            klarna_type: null,
            klarna_order_id: null,
            klarna_token: null,
            klarna_payment_methods: [],
            klarna_order_data: {},*/
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler() {
        this.refresh = true
      }
    }
  },

  computed: {
    user: {
      get() {
        return this.$store.getters["auth/user"]
      }
    },
    computedHeaders() {
      let headers = [
        { text: this.$t("courses.id"), value: "id", sortable: false },
        { text: this.$t("courses.name"), value: "name", sortable: false },
        { text: this.$t("dashboard.duration"), value: "start_datetime", sortable: false },
        //{ text: this.$t('courses.end_datetime'), value: "end_datetime" },
        { text: this.$t("courses.num_places"), value: "num_places", sortable: false },
        { text: this.$t("courses.status"), value: "status", sortable: false },
        { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
      ]

      return headers.filter((h) => !h.hide || !this.$vuetify.breakpoint[h.hide])
    }
  },

  created() {
    let user = localStorage.getItem("__crrntUser")
    if (user) {
      user = JSON.parse(user)
      axios
        .get(this.API_URL + "course/upcoming?instructor_id=" + user.id)
        .then((res) => {
          this.upcomingCourse = res.data.data
        })
        .catch((err) => console.log(err))
    }

    // TEST KLARNA
  },

  methods: {
    list() {
      this.show_loading = true

      let user = this.$store.getters["auth/user"]
      this.search_params.instructor_id = user.id

      if (this.$hasRole("organisation-admin")) {
        delete this.search_params["instructor_id"]
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.API_URL + "courses?resourcetype=course-basic-list&" + query).then((res) => {
        this.courses = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },
    viewCourse(id) {
      if (id) {
        this.$router.push(this.BACKEND_URL + "/courses/edit/" + id)
      }
    },
    checkIn(id) {
      if (id) {
        this.$router.push(this.BACKEND_URL + "/checkin/" + id)
      }
    },
    attendance(id) {
      if (id) {
        this.$router.push(this.BACKEND_URL + "/courses/attendance/" + id)
      }
    }
    /*paymentStart() {
            // PAYMENT API
            let order_data = {
                "purchase_country": "NO",
                "purchase_currency": "NOK",
                "locale": "en-US",
                "order_amount": 1230000,
                "order_lines": [{
                    "name": "Brakomp Personal Registration",
                    "quantity": 1,
                    "unit_price": 1230000,
                    "total_amount": 1230000
                }]
            };
            
            this.klarna_type = "payment";       
            this.klarna_order_data = order_data;
            this.klarna_show = true;
        },
        checkOutStart() {
            // CHECKOUT API
            let order_data = {
                "purchase_country": "NO",
                "purchase_currency": "NOK",
                "locale": "en-US",
                "order_amount": 1230000,
                "order_tax_amount": 0,
                "order_lines": [{
                    "name": "Brakomp Personal Registration",
                    "quantity": 1,
                    "unit_price": 1230000,
                    "tax_rate": 0,
                    "total_amount": 1230000,
                    "total_tax_amount": 0
                }],
                "merchant_urls": {
                    "terms": "https://www.example.com/terms.html",
                    "checkout": "https://www.example.com/checkout.html",
                    "confirmation": `https://${window.location.hostname}/f/klarna/checkout/order-confirmation/{checkout.order.id}`,
                    "push": "https://www.example.com/api/push"
                }
            };

            this.klarna_type = "checkout";       
            this.klarna_order_data = order_data;
            this.klarna_show = true;
        },
        klarnaSuccess(data) {
            this.$awn.success("Order ID: " + data.order_id)
            this.klarnaClear();
        },
        klarnaFailed(data) {
            let error = data.error || this.$t('auth.invalidrequest_t')
            this.$awn.alert(error);
            this.paymentClear();
        },
        klarnaClear() {
            this.klarna_order_data = {};
            this.klarna_show = false;
        },*/
  }
}
</script>

<style>
.v-data-table.upcoming-courses table td {
  height: 31px !important;
}
.v-data-table.upcoming-courses table th {
  height: 31px !important;
}
.v-data-table.upcoming-courses table td .cstm-v-btn {
  height: 24px !important;
}
.widget-course:hover {
  cursor: pointer;
}
.course-status {
  text-transform: uppercase;
  letter-spacing: 2px;
}
</style>
